import { LiveStreamResponse } from "@api-types/event/LiveStreamResponse";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

export class EventLiveStreamApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/live-stream`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async getStreamUrl(
		eventId: string,
		streamType: string = "hls"
	): Promise<LiveStreamResponse> {
		const context = getApiRequestContext();

		const url = `${this.baseUrl}/${eventId}/${streamType}`;
		return httpClient.get(url, this.getRequestHeaders(context));
	}
}
